<template>
<svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24.6849 0.556641H2.28492C1.05292 0.556641 0.0449219 1.56464 0.0449219 2.79664V25.1966C0.0449219 26.4286 1.05292 27.4366 2.28492 27.4366H24.6849C25.9169 27.4366 26.9249 26.4286 26.9249 25.1966V2.79664C26.9249 1.56464 25.9169 0.556641 24.6849 0.556641Z" fill="#034752"/>
  <path d="M11.805 11.309L14.885 6.82902C15.445 5.98902 16.229 5.54102 17.125 5.54102C17.853 5.54102 18.525 5.82102 19.085 6.32502C19.645 6.88502 19.925 7.50102 19.925 8.22902C19.925 8.78902 19.757 9.23702 19.477 9.68501L16.677 13.717L20.093 18.029C20.429 18.477 20.597 18.981 20.597 19.541C20.597 20.325 20.317 20.941 19.813 21.501C19.253 22.061 18.637 22.341 17.853 22.341C17.013 22.341 16.397 22.061 15.949 21.501L11.805 16.405V19.261C11.805 20.101 11.637 20.717 11.357 21.165C10.853 22.005 10.069 22.397 9.11705 22.397C8.22105 22.397 7.54905 22.117 7.04505 21.501C6.59705 20.941 6.37305 20.213 6.37305 19.261V8.62102C6.37305 7.72502 6.59705 7.05302 7.10105 6.43702C7.60505 5.82102 8.27705 5.54102 9.11705 5.54102C9.95705 5.54102 10.629 5.82102 11.189 6.43702C11.469 6.77302 11.693 7.10902 11.749 7.44502C11.805 7.66902 11.805 8.06102 11.805 8.62102V11.309V11.309Z" fill="white"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>